import {DOCUMENT, Inject, Injectable} from '@angular/core';
import {AuthRedirectStorageService} from "@spartacus/core";

@Injectable({
    providedIn: 'root',
})
export class AimoAuthRedirectStorageService extends AuthRedirectStorageService {
    constructor(@Inject(DOCUMENT) protected document: Document) {
        super();
    }

    setRedirectUrl(redirectUrl: string | undefined): void {
        if (redirectUrl === undefined || redirectUrl?.indexOf('followExternalRedirects=true') >= 0) {
            super.setRedirectUrl(redirectUrl);
        }
    }
}
